"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _IconButton = _interopRequireDefault(require("../Buttons/IconButton"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const s = {
  Paginator: _styledComponents.default.div.withConfig({
    displayName: "Paginator",
    componentId: "design-system__pspbj2-0"
  })(["display:flex;align-items:center;box-sizing:border-box;"]),
  Arrows: _styledComponents.default.div.withConfig({
    displayName: "Paginator__Arrows",
    componentId: "design-system__pspbj2-1"
  })(["display:flex;button{margin-right:.5em !important;}"]),
  Pages: _styledComponents.default.div.withConfig({
    displayName: "Paginator__Pages",
    componentId: "design-system__pspbj2-2"
  })(["margin-left:.5em;"])
};

const Paginator = _ref => {
  let {
    pages,
    setPage,
    onPageChange,
    className
  } = _ref;
  const [currentPage, setCurrentPage] = (0, _react.useState)(1);
  const configArrows = [{
    arrowType: 'double_arrow',
    eventType: 'first',
    disableCondition: page => page === 1,
    iconRotate: null
  }, {
    arrowType: 'arrow_right',
    eventType: 'prev',
    disableCondition: page => page === 1,
    iconRotate: 180
  }, {
    arrowType: 'arrow_right',
    eventType: 'next',
    disableCondition: page => page >= pages
  }, {
    arrowType: 'double_arrow',
    eventType: 'last',
    disableCondition: page => page >= pages,
    iconRotate: 180
  }];

  const callbackEvents = (page, direction) => {
    setCurrentPage(page);
    onPageChange({
      currentPage: page,
      direction
    });
  };

  const handlePaginate = direction => {
    switch (direction) {
      case 'first':
        callbackEvents(1, direction);
        break;

      case 'last':
        callbackEvents(+pages, direction);
        break;

      case 'next':
        callbackEvents(currentPage + 1, direction);
        break;

      case 'prev':
        callbackEvents(currentPage - 1, direction);
        break;

      default:
        return false;
    }

    return false;
  };

  const updatePage = page => {
    const MIN = 1;
    const MAX = +pages;
    if (page > MAX) return setCurrentPage(MAX);
    if (page < MIN) return setCurrentPage(MIN);
    return setCurrentPage(page);
  };

  (0, _react.useEffect)(() => {
    updatePage(setPage);
  }, [setPage]);
  return /*#__PURE__*/_react.default.createElement(s.Paginator, {
    className: className
  }, /*#__PURE__*/_react.default.createElement(s.Arrows, null, configArrows.map(_ref2 => {
    let {
      arrowType,
      eventType,
      disableCondition,
      iconRotate
    } = _ref2;
    return /*#__PURE__*/_react.default.createElement(_IconButton.default, {
      key: eventType,
      type: arrowType,
      onClick: () => handlePaginate(eventType),
      disabled: disableCondition(currentPage),
      iconRotate: iconRotate
    });
  })), /*#__PURE__*/_react.default.createElement(s.Pages, null, "Page ".concat(currentPage, " of ").concat(pages)));
};

Paginator.propTypes = {
  setPage: _propTypes.default.number,
  className: _propTypes.default.string,
  pages: _propTypes.default.string,
  onPageChange: _propTypes.default.func
};
Paginator.defaultProps = {
  setPage: null,
  className: '',
  pages: '1',
  onPageChange: () => ({
    currentPage: 1,
    direction: ''
  })
};
var _default = Paginator;
exports.default = _default;